import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=7ed5c29e&scoped=true&"
var script = {}
import style0 from "./Btn.vue?vue&type=style&index=0&id=7ed5c29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5c29e",
  null
  
)

export default component.exports